import { render, staticRenderFns } from "./GClassManagementGroupSetting.vue?vue&type=template&id=7552f214&scoped=true&"
import script from "./GClassManagementGroupSetting.vue?vue&type=script&lang=ts&"
export * from "./GClassManagementGroupSetting.vue?vue&type=script&lang=ts&"
import style0 from "./GClassManagementGroupSetting.vue?vue&type=style&index=0&id=7552f214&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7552f214",
  null
  
)

export default component.exports